import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, ErrorHandler} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from './shared/format-datepicker';

// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Main view components
import { RegistrationComponent } from './registration/registration.component';

// Error Components
import { AccessDeniedComponent } from './error/access-denied/access-denied.component';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';
import { ServiceErrorComponent } from './error/service-error/service-error.component';

// Shared Services
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalFooterComponent } from './global-footer/global-footer.component';

// pipes
import { EmailMaskPipe } from './pipe/email-mask.pipe';
import { PhoneMaskPipe } from './pipe/phone-mask.pipe';
import { SSNMaskPipe } from './pipe/ssn-mask.pipe';
import { ValidationPassLen } from './pipe/validation-pass-len.pipe';
import { ValidationPassLow } from './pipe/validation-pass-low.pipe';
import { ValidationPassNum } from './pipe/validation-pass-num.pipe';
import { ValidationUidLen } from './pipe/validation-uid-len.pipe';
import { ValidationPassUp } from './pipe/validation-pass-up.pipe';
import { ValidationUidNum } from './pipe/validation-uid-num.pipe';
import { ValidationUidWord } from './pipe/validation-uid-word.pipe';
import { ValidationPassSc } from './pipe/validation-uid-specialChars.pipe';
import { ValidationPassNoSc } from './pipe/validation-uid-nospecialChars.pipe';
import { HostRedirectPipe } from './pipe/host-redirect.pipe';
import { StepOneComponent } from './registration/step-one/step-one.component';
import { StepTwoComponent } from './registration/step-two/step-two.component';
import { StepThreeComponent } from './registration/step-three/step-three.component';
import { PaperlessAgreementComponent } from './registration/step-two/paperless-agreement/paperless-agreement.component';
import { RegService } from './shared/Reg.Service';
import { AppInsightsService } from './shared/AppInsights.Service';
import { ErrorHandlerService } from './shared/ErrorHandler.Service';

const routes: Routes = [
  { path: '', component: RegistrationComponent },
  { path: 'ces', component: RegistrationComponent },
  { path: 'error', component: ServiceErrorComponent },
  { path: '404', component: PageNotFoundComponent },
  { path: '401', component: AccessDeniedComponent },
  { path: '**', redirectTo: '/404'}
];

@NgModule({
  declarations: [
    AppComponent,
    AccessDeniedComponent,
    PageNotFoundComponent,
    ServiceErrorComponent,
    GlobalHeaderComponent,
    GlobalFooterComponent,
    EmailMaskPipe,
    PhoneMaskPipe,
    SSNMaskPipe,
    ValidationPassLen,
    ValidationPassLow,
    ValidationPassNum,
    ValidationUidLen,
    ValidationUidNum,
    ValidationUidWord,
    ValidationPassUp,
    ValidationPassSc,
    ValidationPassNoSc,
    HostRedirectPipe,
    RegistrationComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    PaperlessAgreementComponent
  ],
  exports: [
    ValidationPassUp,
    ValidationPassLen,
    ValidationPassLow,
    ValidationPassNum,
    ValidationUidLen,
    ValidationUidNum,
    ValidationUidWord,
    ValidationPassSc,
    ValidationPassNoSc,
    HostRedirectPipe
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule.forRoot(routes,{ scrollPositionRestoration: 'enabled' }),
    NgbModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressBarModule
  ],
  providers: [{provide: APP_BASE_HREF, useValue : '/reg/client/' },
              {provide: DateAdapter, useClass: AppDateAdapter},
              {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
              {provide: ErrorHandler, useClass: ErrorHandlerService},
               AppInsightsService, RegService],
  bootstrap: [AppComponent]
})
export class AppModule { }
